var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    className: "bi bi-chevron-left me-2",
    viewBox: "0 0 8 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-180 4 7.5)"
  }, /*#__PURE__*/React.createElement("title", null, "chevron-right"), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1px",
    d: "M0.15805,0.61801c0.10101,-0.10126 0.23816,-0.15817 0.38119,-0.15817c0.14303,0 0.28018,0.05691 0.38119,0.15817l6.46078,6.46078c0.10126,0.10101 0.15817,0.23816 0.15817,0.38119c0,0.14303 -0.05691,0.28018 -0.15817,0.38119l-6.46078,6.46078c-0.21052,0.21053 -0.55185,0.21053 -0.76237,0c-0.21052,-0.21052 -0.21052,-0.55185 0,-0.76237l6.08067,-6.07959v0l-6.08067,-6.07959c-0.10126,-0.10101 -0.15817,-0.23816 -0.15817,-0.38119c0,-0.14303 0.05691,-0.28018 0.15817,-0.38119z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.0d0786e7.svg";
export { ForwardRef as ReactComponent };